import { styled, css, useTheme } from '@vebox/etui-system';
import { mediaMax } from '../utilities/responsive.js';
import { createElement } from 'react';
import '../useDebounce/useDebounce.js';
import '../useWindowSize/useWindowSize.js';
import useResponsive from '../useResponsive/useResponsive.js';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends, d as _objectDestructuringEmpty } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Li, A } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import { darken } from '@vebox/etui-colors';
import '../ClickOutside/ClickOutside.js';
import Tooltip from '../Tooltip/Tooltip.js';
import TileButton from '../TileButton/TileButton.js';

const _excluded = ["isActive", "isDisabled", "theme"];
const SideMenuItemLi = styled(Li).attrs(_ref => {
  let {
      isActive,
      isDisabled,
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    position: 'relative',
    display: 'inline-block',
    listStyle: 'none',
    height: [90, 100, 100, 110],
    width: [100, 110, 110, 120],
    m: [`0 ${theme.spacing.sm}px ${theme.spacing.sm}px 0`, `0 ${theme.spacing.xlg}px ${theme.spacing.xlg}px 0`],
    p: 0,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.fontSizeBase,
    lineHeight: theme.typography.lineHeightBase,
    bg: theme.palette.black[80],
    color: isActive ? theme.palette.common.white : theme.palette.black[20],
    cursor: isDisabled ? 'not-allowed' : 'pointer'
  }, props);
})`
  white-space: nowrap;
  transition: all 0.2s;

  ${({
  theme,
  isDisabled
}) => {
  return css`
      &:hover {
        color: ${isDisabled ? theme.palette.black[20] : theme.palette.common.white};
      }
    `;
}};

  ${({
  theme
}) => mediaMax(theme).xs`
    margin-bottom: ${theme.spacing.sm}px;
    &:not(:last-child) {
      margin-right: ${theme.spacing.sm}px;
    }
  `};
`;

const SideMenuItemA = styled(A).attrs(_ref => {
  let props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return _objectSpread2({
    position: 'relative',
    display: 'flex',
    height: 'inherit',
    width: 'inherit',
    bg: 'inherit',
    color: 'inherit',
    cursor: 'inherit'
  }, props);
})`
  text-decoration: inherit;
`;

const _excluded$1 = ["as", "isSidebarMenuOpen", "title", "active", "disabled", "icon", "onClick", "toggleSidebarMenu", "props", "styles", "bannerText", "showBanner", "toolTipMessage"];
function SideMenuItem(_ref) {
  let {
      as = 'a',
      isSidebarMenuOpen = false,
      title = 'Title',
      active,
      disabled,
      icon,
      onClick,
      toggleSidebarMenu,
      props = {},
      styles = {},
      bannerText = '',
      showBanner = false,
      toolTipMessage = ''
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  const theme = useTheme();
  const {
    screenIsAtMost
  } = useResponsive({
    xs: parseInt(theme.breakpoints[0], 10),
    sm: parseInt(theme.breakpoints[1], 10),
    md: parseInt(theme.breakpoints[2], 10),
    lg: parseInt(theme.breakpoints[3], 10)
  });
  const isSmView = screenIsAtMost('sm');
  const handleOnClick = event => {
    if (disabled) {
      return;
    }
    if (onClick) {
      onClick(event);
      toggleSidebarMenu(event);
    } else {
      toggleSidebarMenu(event);
    }
  };
  const menuLinkProps = _objectSpread2(_objectSpread2({}, rest), {}, {
    tabIndex: isSidebarMenuOpen ? 0 : -1,
    onClick: handleOnClick
  }, props.a);
  return /*#__PURE__*/createElement(Tooltip, {
    message: toolTipMessage,
    placement: "bottom",
    disableToolTip: !toolTipMessage
  }, /*#__PURE__*/createElement(SideMenuItemLi, _extends({}, props.root, {
    isActive: active,
    isDisabled: disabled
  }, styles.root), /*#__PURE__*/createElement(SideMenuItemA, _extends({
    as: as
  }, menuLinkProps), /*#__PURE__*/createElement(TileButton, {
    title: title,
    icon: _objectSpread2(_objectSpread2({}, icon), {}, {
      size: isSmView ? 32 : 48
    }),
    isDisabled: disabled,
    showBanner: showBanner,
    bannerText: bannerText,
    styles: {
      root: {
        bg: theme.palette.black[80],
        borderColor: active ? theme.palette.black[60] : darken(theme.palette.black[60], 0.2),
        hoverBorderColor: theme.palette.black[60],
        hoverBoxShadow: theme.shadows[4],
        opacity: disabled ? 0.2 : 1
      }
    }
  }))));
}

export default SideMenuItem;
